import { useState, useLayoutEffect } from "react";

export const useIsOverflow = (ref, callback, view = "vertical") => {
  const [isOverflow, setIsOverflow] = useState(false);

  useLayoutEffect(() => {
    const { current } = ref;

    const trigger = () => {
      const hasOverflow =
        view === "horizontal"
          ? current?.scrollWidth > current?.clientWidth
          : current?.scrollHeight > current?.clientHeight;

      setIsOverflow(hasOverflow);

      if (callback) {
        // if ("ResizeObserver" in window) {
        //   new ResizeObserver(trigger)?.observe(current);
        // }
        callback(hasOverflow);
      }
    };

    if (current) {
      trigger();
    }
  }, [callback, ref]);

  return isOverflow;
};
